export default "__VITE_ASSET__BMliKY48__"